import { ExpertCabinetSliceState } from './types'

export const selectExpertise: AppSelector<
  ExpertCabinetSliceState['expertise']
> = state => state.expertCabinet.expertise

export const selectScore: AppSelector<
  ExpertCabinetSliceState['integral_score']
> = state => state.expertCabinet.integral_score
